import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const holmesBeachConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Holmes Beach Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Holmes Beach, FL. Sam\'s Tree Service handles hazardous coastal trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_holmes_beach',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Holmes Beach',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

   /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Holmes Beach Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we handle the challenging tree work that 
     comes with island living in <strong>Holmes Beach</strong>. Coastal properties face 
     constant pressure from Gulf winds, salt exposure, and tropical storms all of which 
     break down tree health over time. Whether you have a leaning palm, a storm split oak, 
     or an overgrown canopy crowding your roofline, we have the skills and equipment to 
     resolve it safely.`,

    `We specialize in <strong>hazardous and storm damaged trees</strong> on residential 
     and vacation properties addressing weakened root systems in sandy soil, wind stressed 
     trunks, heavy limbs over structures, and overgrowth that increases your hurricane 
     vulnerability. We work efficiently and cleanly on every job.`,

    `<strong>Sam's Tree Service</strong> offers trusted, professional tree care across 
     <strong>Holmes Beach</strong> and the entirety of <strong>Anna Maria Island</strong> 
     keeping island properties safe, clean, and storm ready throughout the year.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Holmes Beach, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_HolmesBeach = () => <LocationPage config={holmesBeachConfig} />;
export default Services_HolmesBeach;
